"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalyticsAccountSettings = void 0;
var axios_1 = __importDefault(require("axios"));
var swr_1 = __importDefault(require("swr"));
var inversify_react_1 = require("inversify-react");
var Types_1 = require("Reports/Types");
var SimpleAxiosRetry_1 = require("@CommonFrontend/Utils/SimpleAxiosRetry");
var HTTP_MESSAGES_1 = require("@CommonFrontendBackend/Utils/HTTP_MESSAGES");
var useAnalyticsAccountSettings = function () {
    var apiBaseUrl = (0, inversify_react_1.useInjection)("apiBaseUrl");
    var rootDataStore = (0, inversify_react_1.useInjection)("rootDataStore");
    var accountDataStore = rootDataStore.getAccountDataStore();
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var notifiUser = (0, inversify_react_1.useInjection)("notifyUser");
    var onNetworkError = function (persistTime) {
        notifiUser.error(HTTP_MESSAGES_1.ERROR_NETWORK_DISCONNECTED, persistTime);
    };
    var onReconnected = function (persistTime) {
        notifiUser.success(HTTP_MESSAGES_1.SUCCESS_NETWORK_RECONNECTED, persistTime);
    };
    function postHttp(url, data) {
        return updateAccountSettings(url, data, { onNetworkError: onNetworkError, onReconnected: onReconnected });
    }
    var url = "".concat(apiBaseUrl, "/accounts/").concat(accountDataStore.id, "/settings/analytics");
    var _a = (0, swr_1.default)([url], function (args) { return fetchAnalyticsAccountSettings(args); }, {
        dedupingInterval: 60000,
    }), data = _a.data, mutate = _a.mutate;
    function updateCurrency(defaultCurrency) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, postHttp("".concat(url, "/default-currency"), { defaultCurrency: defaultCurrency })];
                    case 1:
                        _a.sent();
                        telemetry.trackOnly(Types_1.ReportTelemetryEventName.AnalyticsAndReportingSettingsChanged, {
                            update_type: "default_currency",
                            update_value: defaultCurrency,
                        }, { blockIntercom: true });
                        return [4, mutate()];
                    case 2:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    function updateCleanup(defaultCleanup) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, postHttp("".concat(url, "/default-cleanup"), { defaultCleanup: defaultCleanup })];
                    case 1:
                        _a.sent();
                        return [4, mutate()];
                    case 2:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    function updateEngagement(engagementSettings) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, postHttp("".concat(url, "/engagement"), { engagement: engagementSettings })];
                    case 1:
                        _a.sent();
                        return [4, mutate()];
                    case 2:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    function updatePageCollections(pageCollections, optimisticData) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, mutate(postPageCollections(pageCollections), {
                            optimisticData: optimisticData,
                            revalidate: false,
                        })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    function postPageCollections(pageCollections) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2, postHttp("".concat(url, "/page-collections"), {
                        pageCollections: pageCollections,
                    })];
            });
        });
    }
    return {
        data: data,
        updateCurrency: updateCurrency,
        updateCleanup: updateCleanup,
        updateEngagement: updateEngagement,
        updatePageCollections: updatePageCollections,
    };
};
exports.useAnalyticsAccountSettings = useAnalyticsAccountSettings;
function updateAccountSettings(url, payload, handlers) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            return [2, (0, SimpleAxiosRetry_1.retryOnNetworkError)(function (axiosInstance) { return axiosInstance.post(url, payload); }, handlers)];
        });
    });
}
var fetchAnalyticsAccountSettings = function (_a) { return __awaiter(void 0, [_a], Promise, function (_b) {
    var data;
    var _c = __read(_b, 1), url = _c[0];
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4, axios_1.default.get(url, { withCredentials: true })];
            case 1:
                data = (_d.sent()).data;
                return [2, data];
        }
    });
}); };
